<template>
  <div id="management" class="box">
    <vue-loading :active.sync="isSaving" :is-full-page="true" loader="dots" color="#70A1F0"></vue-loading>

    <transition name="fade" appear>
      <div class="row">
        <div class="col-4">
          <h4>Create New Group</h4>
          <hr/>
          <form @submit.prevent="createGroup()">
            <div class="form-group">
              <h5>Group Name</h5>
              <div class="form-row">
                <div class="col">
                  <input type="text" class="form-control details-input" v-model="group" required>
                </div>
              </div>
            </div>
            <div class="form-group">
              <h5>Contracts</h5>
              <div class="form-row" style="margin-bottom: 5px;" v-for="(contract,index) in contractList" :key="index">
                <div class="col">
                  <input type="text" class="form-control details-input" :id="'contract-'+index" v-model="contractList[index]" required>
                </div>
                <div class="col">
                  <button type="button" class="btn btn-danger" @click="deleteContract(index)">Delete</button>
                </div>
              </div>
            </div>
            <div>
              <button type="button" class="btn btn-success" @click="addContract()">Add Contract</button>
              <button class="btn btn-primary">Save</button>
            </div>
          </form>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import HTTP from '@/common/http'
import VueLoading from 'vue-loading-overlay'

export default {
  name: 'GroupNew',
  components: {
    VueLoading
  },
  data () {
    return {
      isSaving: false,
      group: null,
      contractList: [null]
    }
  },
  methods: {
    createGroup: function () {
      if (this.contractList.length < 1) {
        this.flashMessage.error({
          message: 'at least one contract must be added to the group'
        })
      } else {
        this.isSaving = true
        const requests = this.contractList.map((contract) => {
          HTTP.put(`/management/group/${this.group}/contract/${contract}`)
        })
        Promise.all(requests)
          .then(() => {
            this.flashMessage.success({
              message: `Successfully created group ${this.group}`
            })
            setTimeout(() => {
              this.isSaving = false
              this.$router.push({ name: 'GroupModify', params: { id: this.group } })
            }, 3000)
          })
          .catch((error) => {
            this.isSaving = false
            var msg = (error.response) ? error.response.data.error : error.message
            this.flashMessage.error({
              message: `Failed to create ${this.group} : ${msg}`
            })
          })
      }
    },
    deleteContract: function (index) {
      this.contractList.splice(index, 1)
    },
    addContract: function () {
      this.contractList.push(null)
    }
  }
}
</script>

<style scoped>
h4 {
  margin-top: 15px;
}
.row {
  padding: 20px;
}
.details-input {
  max-width: 300px;
  margin-right: 20px;
  float: left;
}
</style>

<style scoped src='../assets/stylesheet/transitions.css'></style>



// WEBPACK FOOTER //
// src/views/GroupNew.vue